import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdminTravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/admin-travel-grid-model';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AdminTravelReimbursementGridWidgetService } from 'common/widget/travel-reimbursement/admin-travel-reimbursement-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class AdminTravelReimbursementGridResolver extends GridResolver<TravelReimbursementModel, AdminTravelReimbursementListingModel> {
    constructor(
        protected fs: AdminTravelReimbursementGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}